import get from 'lodash-es/get';
import React from 'react';

import { useConstants } from '../../../../hooks/useConstants';
import Select from '../../../forms/Select';

type ApiProps = {
  name?: string;
};

export default function Api({ name }: ApiProps) {
  const { constants } = useConstants();

  const ACCEPTED_API = get(constants, 'CREATIVE.ACCEPTED_API', {});
  const options = Object.entries(ACCEPTED_API).map(([value, label]) => ({ value, label }));

  return (
    <Select
      label="API"
      name={name || 'api'}
      rules={{
        required: 'Please enter an API.',
      }}
      options={options}

    />
  );
}
